import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import { DatePicker } from 'material-ui-pickers';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import {
  JobBasics,
  JobSummary,
  JobDescription,
  JobMetrics,
} from '../Detail';

import { selectClientJobs } from '../../../../store/selectors';
import { startEditProject } from '../../../../store/actions/projects';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start'
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  dates: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  field: {
    marginBottom: theme.spacing.unit*2,
    minWidth: '300px',
  },
});

const DetailCards = ({ classes, project, clients, clientJobs, startEditProject }) => {

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <JobBasics project={project} />
        <JobSummary />
      </div>

      {false &&
        <div className={classes.row}>
          <JobDescription project={project} />
          <JobMetrics />
        </div>
      }
      
    </div>
  );
};

const mapStateToProps = (state) => {
  const clients = state.clientsState;
  return {
    clientJobs: selectClientJobs(state),
    clients,
  }
};

const mapDispatchToProps = (dispatch) => ({
  startEditProject: (projectId, updates) => dispatch(startEditProject(projectId, updates)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(DetailCards);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Detail/DetailCards.jsx